export default __webpack_public_path__ + "static/media/lose.c6864e98.png";